import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;

  .ant-table-thead .ant-table-cell {
    text-align: center !important;
  }

  .ant-table-cell {
    text-overflow: ellipsis;
    white-space: normal;
  };

  th.ant-table-cell.ant-table-cell-scrollbar {
    width: 0;
  }

  .ant-table th span {
    white-space: normal;
  }

  .ant-table-thead .ant-table-cell {
    padding: 8px !important;
  }

  .ant-table-tbody .ant-table-cell {
    padding: 8px 8px 12px !important;
  }

  th {
    font-size: 14px !important;
    font-weight: 700 !important;
    padding: 16px 8px !important;
    color: #000 !important;
  }

  td {
    background-color: transparent !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #000 !important;
  }

  &:not(.ant-table-empty) tr:hover {
    background-color: #d9d9d9 !important;
  }

  .ant-table-empty tr:hover {
    background-color: inherit !important;
  }

  tr {
    background-color: #ffffff;
  }

  tr:nth-child(odd) {
    background-color: #f5f5f5;
  }
`;
